'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _cloneDeep2 = require('lodash/cloneDeep');

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

var _update2 = require('lodash/update');

var _update3 = _interopRequireDefault(_update2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

exports.default = createPlayer;

var _scriptLoader = require('@spp/script-loader');

var _scriptLoader2 = _interopRequireDefault(_scriptLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_PLAYER_URL = 'https://cdn.svp.schibsted.io/player/1.12.9/player.min.js'; /* global window */


var svpPlayerReady = null;

/* From player version 3.0.0 and forward there is an optimized
 * version available for modern browsers with less polyfills
 */
function getOptimizedPlayerUrl(playerUrl) {
    if (playerUrl.indexOf('/1.') <= 0 && playerUrl.indexOf('/2.') <= 0) {
        try {
            eval('async () => {}'); // eslint-disable-line
            return playerUrl.replace('player.min', 'player.next.min');
        } catch (a) {} // eslint-disable-line
    }

    return playerUrl;
}

function initializeSvpPlayer() {
    var playerUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_PLAYER_URL;
    var antiAdblock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var antiAdblockConfigUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

    if (!svpPlayerReady) {
        svpPlayerReady = new _promise2.default(function (resolve, reject) {
            window.onSvpPlayerReady = function () {
                if (antiAdblock) {
                    window.SVP.Player.defaults = {
                        aab: true
                    };

                    if (antiAdblockConfigUrl) {
                        window.SVP.Player.defaults.aabConfig = antiAdblockConfigUrl;
                    }
                }
                resolve();
            };

            var finalUrl = getOptimizedPlayerUrl(playerUrl);

            (0, _scriptLoader2.default)(finalUrl).catch(function (e) {
                svpPlayerReady = null;
                reject(e);
            });
        });
    }
    return svpPlayerReady;
}

function getVideoAssetFormat(asset) {
    var height = (0, _get3.default)(asset, 'sourceFiles[0].height');
    var width = (0, _get3.default)(asset, 'sourceFiles[0].width');

    if (!height || !width) return 'normal'; // Default if sourcefiles are missing
    if (height === width) return 'square';
    if (height > width) return 'vertical';

    return 'normal';
}

function getPulseTags(asset) {
    var inArticle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var startMode = arguments[2];

    var tags = inArticle ? ['inarticle'] : [];
    var format = getVideoAssetFormat(asset);

    if (format !== 'normal') tags.push(format);
    if (startMode === 'silent') tags.push('silentplay');

    return tags;
}

function getPulseFlags(asset, firstVideoAssetId, startMode, autoplayNext) {
    var flags = [];

    if (startMode === 'silent' && asset.id === firstVideoAssetId) {
        flags.push('NOPREROLLS');
    }

    if (autoplayNext && asset.nextAssetId) {
        flags.push('NOPOSTROLLS');
    }

    return flags;
}

function createPlayer(params) {
    var videoPlayerUrl = params.videoPlayerUrl,
        antiAdblock = params.antiAdblock,
        antiAdblockConfigUrl = params.antiAdblockConfigUrl,
        _params$videoAsset = params.videoAsset,
        videoAsset = _params$videoAsset === undefined ? {} : _params$videoAsset,
        getPlayerConfig = params.getPlayerConfig,
        inArticle = params.inArticle,
        autoplayNext = params.autoplayNext,
        node = params.node,
        startMode = params.startMode,
        getCurrentAsset = params.getCurrentAsset;


    return initializeSvpPlayer(videoPlayerUrl, antiAdblock, antiAdblockConfigUrl).then(function () {
        var actualStartMode = startMode;
        if (startMode === 'silent' && window.SVP.Player.canDeviceAutoplay() === 'never') {
            actualStartMode = 'manual';
        }

        var baseConfig = {
            node: node,
            id: parseInt(videoAsset.id, 10),
            autoplay: actualStartMode === 'auto',
            settings: {
                pulse: function pulse(asset) {
                    return {
                        contentMetadata: {
                            tags: getPulseTags(asset, inArticle, actualStartMode),
                            flags: getPulseFlags(asset, videoAsset.id, actualStartMode, autoplayNext)
                        }
                    };
                }
            },
            recommended: {
                next: false,
                // Using the grid would not have any real video JSON available for playerSetup
                grid: false,
                autoplay: false
            }
        };

        if (actualStartMode === 'silent') {
            baseConfig.mute = true;
        }

        var config = getPlayerConfig(baseConfig, { startMode: actualStartMode });

        // settings.pulse could also be a raw object
        // If it is a function, we act as proxy for the correct asset JSON
        if (typeof (0, _get3.default)(config, 'settings.pulse') === 'function') {
            (0, _update3.default)(config, 'settings.pulse', function (pulse) {
                return function () {
                    return pulse(getCurrentAsset());
                };
            });
        }

        // During the overlap between ooyala and appnexus as video ad provider, we support both
        if (typeof (0, _get3.default)(config, 'adn') === 'function') {
            (0, _update3.default)(config, 'adn', function (adn) {
                return function () {
                    return adn(getCurrentAsset());
                };
            });
        }

        return new window.SVP.Player((0, _cloneDeep3.default)(config));
    });
}
//# sourceMappingURL=create-player.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/video-asset/lib/cjs/create-player.js
 ** module id = 707
 ** module chunks = 1
 **/